import mime from "mime-types";
import { fileTypeFromBlob } from "file-type";
export const determineMimeType = async (relativePath, fileContent) => {
    let mimeType = mime.lookup(relativePath);
    if (mimeType === false) {
        const fileType = await fileTypeFromBlob(fileContent);
        if (fileType !== undefined) {
            mimeType = fileType.mime;
        }
        else {
            mimeType = "application/octet-stream";
        }
    }
    return mimeType;
};
// TODO should be a stock solution. mime module currently does not work, and we do not have content at hand
export function guessMimeType(fileName) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
        return undefined;
    }
    const extension = fileName.substring(dotIndex + 1);
    switch (extension) {
        case "zip":
            return "application/zip";
        case "jpg":
            return "image/jpg";
        case "jpeg":
            return "image/jpeg";
        case "png":
            return "image/png";
        case "pdf":
            return "application/pdf";
        case "json":
            return "application/json";
        default:
            return undefined;
    }
}
export async function reevaluateFileMimeType(path, file) {
    let typedFile;
    if (file.type === "application/octet-stream" || file.type === "text/plain") {
        const mimeType = await determineMimeType(path, file);
        typedFile = new File([file], file.name, {
            type: mimeType,
            lastModified: file.lastModified,
        });
    }
    else {
        typedFile = file;
    }
    return typedFile;
}
